/** On-demand favicon URL for a page or API host (Google's public favicon service). */
export function faviconUrlForPageUrl(
	url: string,
	size: 16 | 32 | 64 | 128 = 64,
): string | null {
	try {
		const hostname = new URL(url).hostname
		if (!hostname) return null
		return `https://www.google.com/s2/favicons?domain=${encodeURIComponent(hostname)}&sz=${size}`
	} catch {
		return null
	}
}
